// test2423
(2423 && 0);
